import React from 'react';
import Modal from 'react-responsive-modal';
import Translate from 'translate';
import { Card, CardText } from 'material-ui';

export default ( { data, onClose, open } ) => {
  return (
    <Modal closeOnEsc={false}
           little
           modalClassName="col-md-4"
           open={open}
           onClose={onClose}>
      <h5 className="mt-0"><Translate id="imsDetail"/></h5>
      { data && data.result===false &&
      <div className="col-md-12 text-center">
            <h5 className="text-muted mt-0"><Translate id="noDataFound"/></h5>
      </div>
      }
      { data && data.result!==false &&
      <Card>

      
      <CardText>
      <div className="col-md-12 p-0">
        <div className="row">
          <div className="col-md-3"><Translate id="complaintNumber"/></div>
          <div className="col-md-9 text-small text-muted">{data.complaintNumber}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="accountNumber"/></div>
          <div className="col-md-9 text-small text-muted">{data.accountNumber}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="accountName"/></div>
          <div className="col-md-9 text-small text-muted">{data.accountName}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="status"/></div>
          <div className="col-md-9 text-small text-muted">{data.status || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="phoneNumber"/></div>
          <div className="col-md-9 text-small text-muted">{data.phoneNumber || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="creationDate"/></div>
          <div className="col-md-9 text-small text-muted">{data.creationDate || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="resolutionDate"/></div>
          <div className="col-md-9 text-small text-muted">{data.resolutionDate || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="incident"/></div>
          <div
            className="col-md-9 text-small text-muted">{data.incident || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="incidentCause"/></div>
          <div
            className="col-md-9 text-small text-muted">{data.incidentCause || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="incidentDescription"/></div>
          <div
            className="col-md-9 text-small text-muted">{data.incidentDescription || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="substation"/></div>
          <div className="col-md-9 text-small text-muted">
            {data.substation ? `${data.substation}` : '---'}
          </div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="feeder"/></div>
          <div className="col-md-9 text-small text-muted">
            {data.feeder ? `${data.feeder}` : '---'}
          </div>
        </div>

      </div>
      </CardText></Card>
      }
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./routes/app/components/Agent/CheckImsModal/index.js